// This file is automatically generated by version.js

export const VERSION: { name: string, version: string, pipeline: string, sha: string, branch: string } = {
  name:     'cars-webapp',
  version:  '0.0.0',
  pipeline: '314616',
  branch:   'master',
  sha:      '21a30fb11e3588cf8d154dd7bea000f2df68ab04'
};
